
import PrimeNavbar from './components/PrimeNavbar';
import HeroSection from './components/HeroSection';
import DiagnosisSection from './components/DiagnosisSection';
import FunnelsSection from './components/FunnelsSection';
import ComparisonSection from './components/ComparisonSection';
import TrustSection from './components/TrustSection';
import PartnersSection from './components/PartnersSection';
import AnalysisForm from './components/AnalysisForm';
import PrimeFooter from './components/PrimeFooter';

export default function PrimeSalesPage() {
  return (
    <div className="min-h-screen bg-white">
      <PrimeNavbar />
      <HeroSection />
      <DiagnosisSection />
      <FunnelsSection />
      <ComparisonSection />
      <TrustSection />
      <PartnersSection />
      <AnalysisForm />
      <PrimeFooter />
    </div>
  );
}
